import { render, staticRenderFns } from "./Recetario.vue?vue&type=template&id=2a85d531&"
import script from "./Recetario.vue?vue&type=script&lang=js&"
export * from "./Recetario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports